import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomInputGroupModule } from '../custom-input-group/custom-input-group.module';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { ManageIdentitiesModule } from '../manage-identities/manage-identities.module';
import { PersonAvatarModule } from '../person-avatar/person-avatar.module';
import { PipesModule } from '../pipes/pipes.module';
import { HealthPackageSlotComponent } from './health-package-slot.component';
import { ConsultationTypeModalModule } from '../consultation-type-modal/consultation-type-modal.module';



@NgModule({
  declarations: [HealthPackageSlotComponent],
  imports: [
    CommonModule,
    PersonAvatarModule, 
    PipesModule,
    ManageIdentitiesModule,
    FormInputErrorModule,
    CustomInputGroupModule,
    ConsultationTypeModalModule
  ],
  exports: [
    HealthPackageSlotComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class HealthPackageSlotModule { }
